import styled from 'styled-components';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { useContext, useState } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { logEvent } from '../../../../new-lib/analytics';
import { SearchViewTypes } from '../../../../new-lib/constants/common';
import { updateQuery } from '../../../../helpers/common';
import CheckboxPresentation from '../../../search/components/search-filters/checkbox-view/CheckboxPresentation';

const PropertyFeaturesFilter = () => {
  const { filterOptions, searchFiltersState, searchFiltersDispatch } =
    useContext(SearchContext) as SearchContextInterface;
  const router = useRouter();
  const [selectedValues, setSelectedValues] = useState<any>([]);

  const options = [
    {
      filterType: SearchFiltersTypes.AMENITIES,
      value: 1,
      options: { displayedValue: 'garden' }
    },
    {
      filterType: SearchFiltersTypes.AMENITIES,
      value: 2,
      options: { displayedValue: 'roof' }
    }
  ];
  const handleChange = (filterType: any, option?: any) => {
    let newValues = selectedValues;
    if (selectedValues.includes(option?.value)) {
      newValues = selectedValues.filter((value: any) => value !== option.value);
    } else {
      newValues = [...selectedValues, option.value];
    }
    setSelectedValues(newValues);
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
      payload: {
        name: SearchFiltersTypes.AMENITIES,
        value: newValues
      }
    });
    if (router.query?.view !== SearchViewTypes.MAP) {
      updateQuery(
        router,
        [{ name: SearchFiltersTypes.AMENITIES, value: newValues.toString() }],
        undefined
      );
    }

    if (newValues.length == 0 && router.query?.view !== SearchViewTypes.MAP) {
      updateQuery(
        router,
        [
          ...(!router.asPath.includes('/nawy-now')
            ? [{ name: 'page_number', value: 1 }]
            : [])
        ],
        [SearchFiltersTypes.AMENITIES]
      );
      updateQuery(router, [], [SearchFiltersTypes.AMENITIES]);
    }

    logEvent.search(
      `filter_${SearchFiltersTypes.AMENITIES}`,
      'filtersMenu',
      'filter',
      searchFiltersState
    );
  };

  return <CheckboxPresentation options={options} handleChange={handleChange} />;
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    width: 100%;
  }

  .header {
    font-size: 18px;
    font-family: materialSemiBold;
    color: #282828;
  }
`;
const Option = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row-reverse;
  padding: 16px;
  gap: 8px;
  border-radius: 7.5px;
  background-color: #f9fafb;

  &.dimmed {
    pointer-events: none;
    background-color: #e0e0e0;
    color: #818181;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .type {
    font-size: 14px;
    color: #000000;
    font-family: materialMedium;
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 1px solid #d1d4d9;
    background-color: #fff;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const CustomCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1px solid #d1d4d9;
  background: #fff;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:checked {
    background-color: #fff;
    border-color: #d1d4d9;
  }

  &:disabled {
    background-color: #fff;
    border-color: #d1d4d9;
  }

  &:checked::before {
    content: '✓';
    display: block;
    text-align: center;
    color: #015c9a;
  }
`;

export default PropertyFeaturesFilter;
